import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { label } from 'src/app/constants/labels';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { BaseAPIService } from 'src/app/shared/services/api.base.service';
import { environment } from 'src/environments/env-proxy';
import * as Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import offline from 'highcharts/modules/offline-exporting';
import { saveAs } from 'file-saver';
import { totalApps } from 'src/app/models/totalApps';
import { totalTickets } from 'src/app/models/totalTickets';
exporting(Highcharts);
offline(Highcharts);

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  isAdmin: string;
  labels = label;
  chart1;
  chart2;
  serverUrl = environment.serverUrl;
  timeListDrop = ['Last 1 Week', 'Last 1 Month', 'Last 6 Months', 'Last 1 Year'];
  timeListDropGraph = [this.timeListDrop[2], this.timeListDrop[3]];
  monthNumber = [6,7,12];
  webApplications = [];
  winApplications = [];
  ticketTimeChange = this.timeListDrop[0];
  pieAppSelection = 0;
  selectedApp = this.webApplications[0];
  DownloadTime = this.timeListDrop[0];
  barTimeSelection = this.timeListDropGraph[0];
  loading: boolean;
  appsList: [];
  gridView: boolean;
  widgetLoader = {
    tableone: false,
    tabletwo: false,
    totalUsers: false,
    userAccessCount: false,
    totalDownloads: false,
    pieGraphloaded: false,
    barGraphloaded: false,
    regionData: false,
    totalTickets: false
  };
  response = {
    accessTableData: [],
    downloadTableData: [],
    totalUsers: null,
    accessedApps: null,
    totalDownloads: null,
    totalOpenTickets: null,
    totalClosedTickets: null,
    highPriorityTickets: null,
    lowPriorityTickets: null,
    mediumPriorityTickets: null
  }
  colsTab2: { field: string; header: string; width: string}[];
  colsTab1: { field: string; header: string; width: string}[];
  accessedAppId: number;
  selectedWinApp: number;
  downloadTime: string = this.timeListDrop[0];
  barxaxisdata = [];
  barUsersData = [];
  pieChartData;
  searchText = '';
  date = new Date();
  platformIdentifer : string;

  constructor(private readonly authenticationService: AuthenticationService, private readonly baseService: BaseAPIService, private readonly toastr: ToastrService) { }

  /**
   * initialization  of Statistics component
   * returns statistics of service portal.
   */
  ngOnInit() {
    this.labels = label;
    this.accessedAppId = 0;
    this.selectedWinApp = 0;
    this.gridView = false;
    this.colsTab1 = [
      { field: 'name', header: 'Name', width: '25%' },
      { field: 'iA3', header: 'IA3', width: '25%' },
      { field: 'migrationExpert', header: 'Migration Expert', width: '25%'},
      { field: 'plcConverter', header: 'PLC Converter', width: '25%'}
    ];
    this.colsTab2 = [
      { field: 'name', header: 'Name', width: '25%' },
      { field: 'applictaionName', header: 'Application Name', width: '25%' },
      { field: 'fileName', header: 'FileName', width: '25%' },
      { field: 'timestamp', header: 'Downloaded On (UTC)', width: '25%' },
    ];

    this.isAdmin = this.authenticationService.adminRole;
    if (this.isAdmin === 'false') {
      this.authenticationService.logout();
    }

    this.getTotalUsers();
    this.getAllWebApps();
    this.getAllWinApps();
    this.timeChange('download');
    this.timeChangeBarGraph('barGraph');
    this.getNumberOfUserAccessed();
    this.pieAppChange();
    this.getUserApplictaionAccess();
    this.getUserApplictaionDownloads();
    this.getTotalTickets('ticket');

  }
  /**
   * Gets the StartDate and EndDate for getting tickets 
   * return start and End Dates.
   */
  getTotalTickets(val: string) {
    if (val === 'ticket') {
      let tktweekNum = 0;
      let tktmonthNum = this.monthNumber[0];
      if (this.ticketTimeChange === this.timeListDrop[0]) {
        tktweekNum = 1;
      }
      if (this.ticketTimeChange === this.timeListDrop[1]) {
        tktmonthNum = 1;
      }
      if (this.ticketTimeChange === this.timeListDrop[2]) {
        tktmonthNum = this.monthNumber[0];
      }
      if (this.ticketTimeChange === this.timeListDrop[3]) {
        tktmonthNum = this.monthNumber[2];
      }
      let tktstartDate = '';
      let tktendDate = '';
      if (tktweekNum === 0) {
        const d = new Date();
        tktendDate = d.toLocaleDateString('en-US');
        d.setMonth(d.getMonth() - tktmonthNum);
        tktstartDate = d.toLocaleDateString('en-US');
      } else {
        const d = new Date();
        tktendDate = d.toLocaleDateString('en-US');
        d.setDate(d.getDate() - this.monthNumber[1]);
        tktstartDate = d.toLocaleDateString('en-US');
      }
      this.getTicketsCount(tktstartDate, tktendDate);
    }
  }

  /**
   * Gets the Total Open and closed Tickets
   * return Open Tickets and closed tickets count.
   */
  getTicketsCount(stDate, endDate) {
    this.widgetLoader.totalTickets = true;
    this.response.highPriorityTickets = null;
    this.response.mediumPriorityTickets = null;
    this.response.lowPriorityTickets = null;

    this.baseService.GET(`${this.serverUrl}/api/Support/GetTicketStatisticsByAppIdAndDate?stDate=${stDate}&endDate=${endDate}` )
    .subscribe((data: [totalTickets]) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].key === 'OpenTicketCount') {
            this.response.totalOpenTickets = data[i].value;
          } else if (data[i].key === 'ClosedTicketCount') {
            this.response.totalClosedTickets = data[i].value;
          } else if(data[i].key === 'High') {
            this.response.highPriorityTickets = data[i].value
          } else if(data[i].key === 'Medium') {
            this.response.mediumPriorityTickets = data[i].value
          } else if(data[i].key === 'Low') {
            this.response.lowPriorityTickets = data[i].value
          } else {
            //sonar fix
          }
        }
        this.widgetLoader.totalTickets = false;
      });
  }


  /**
   * Gets the total number of Users in service poratl
   * return total users count.
   */
  getTotalUsers() {
    this.widgetLoader.totalUsers = true;
    this.baseService.GET(this.serverUrl + '/api/Dashboard/GetTotalUserinServicePortal').subscribe((response: totalApps) => {
      this.response.totalUsers = response.value;
      this.widgetLoader.totalUsers = false;
    },
    /* istanbul ignore next */

      (_error) => {
        this.widgetLoader.totalUsers = false;
        this.toastError();
      });
  }
  /**
   * Gets the total webApps
   * return total web applications list.
   */
  getAllWebApps() {
    this.baseService.GET(this.serverUrl + '/api/Dashboard/GetAllWebApps').subscribe((response: []) => {
      this.webApplications = response;
    },
    /* istanbul ignore next */
      (_error) => {
       this.toastError();
      });
  }
   /**
   * Gets the total Windows apps
   * return total windows applications list.
   */
  getAllWinApps() {
    this.baseService.GET(this.serverUrl + '/api/Dashboard/GetAllDesktopApps').subscribe((response: []) => {
      this.winApplications = response;
    },
    /* istanbul ignore next */
      (_error) => {
       this.toastError();
      });
  }
   /**
   * Shows the actual error
   * return error message string.
   */
  toastError(){
    this.toastr.error(label.errorFetchingDataReloading, '', {
      timeOut: environment.toasterTimeOut
    });
  }
   /**
   * Gets the Number of users accessed count 
   * return total accessed users count.
   */
  getNumberOfUserAccessed() {
    this.widgetLoader.userAccessCount = true;
    this.baseService.GET(`${this.serverUrl}/api/Dashboard/GetNumberOfUsersAccess/${this.accessedAppId}`).subscribe((response:totalApps ) => {
      this.response.accessedApps = response.value;
      this.widgetLoader.userAccessCount = false;
    },
    /* istanbul ignore next */
      (_error) => {
       this.toastError();
      });
  }
   /**
   * Generate the charts(bar chart and Pie Chart)
   * generates Graph SVG .
   */
  generateChart() {
    Highcharts.setOptions({ colors: ['#26A6E0', '#1A79A9', '#F7A35C', '#90ED7D', '#434348', '#434348'] });
    this.chart1 = Highcharts.chart('container', this.optionsHighChart);
    this.chart2 = Highcharts.chart('PieChart', this.optionPieChart);
    this.gridView = false;
  }
   /**
   * Gets the total number of users wrt application
   * return total number users wrt application
   */
  pieAppChange() {
    this.widgetLoader.pieGraphloaded = true;
    this.baseService.GET(this.serverUrl + `/api/Dashboard/GetNumberOfUsersWRTApplicationForPieChart`).subscribe((data) => {
      this.optionPieChart.series[0].data = [];
      this.pieChartData = data;
      this.widgetLoader.pieGraphloaded = false;
      for (let i = 0; i < this.pieChartData.length; i++) {
        const obj = {
          name: '',
          y: null,
          sliced: false,
          selected: false
        }
        obj.name = this.pieChartData[i].key;
        obj.y = this.pieChartData[i].value;
        if (i === 0) {
          obj.sliced = true;
          obj.selected = true;
        }
        if (obj.y !== 0) {
          this.optionPieChart.series[0].data.push(obj);
        }
      }
      if (!this.gridView) {
        Highcharts.setOptions({ colors: ['#26A6E0', '#F7A35C', '#1A79A9', '#90ED7D', '#434348', '#434348'] });
        this.chart2 = Highcharts.chart('PieChart', this.optionPieChart);
      }
      this.widgetLoader.pieGraphloaded = false;
    });

  }

   /** 
   * triggers timechange event
   * returns startDate and endDate .
   */
  timeChange(val: string) {
    if (val === 'download') {
      let weekNum = 0;
      let monthNum = this.monthNumber[0];
      if (this.downloadTime === this.timeListDrop[0]) {
        weekNum = 1;
      }
      if (this.downloadTime === this.timeListDrop[1]) {
        monthNum = 1;
      }
      if (this.downloadTime === this.timeListDrop[2]) {
        monthNum =  this.monthNumber[0];
      }
      if (this.downloadTime === this.timeListDrop[3]) {
        monthNum =  this.monthNumber[2];
      }
      let startDate = '';
      let endDate = '';
      if (weekNum === 0) {
        const d = new Date();
        endDate = d.toLocaleDateString('en-US');
        d.setMonth(d.getMonth() - monthNum);
        startDate = d.toLocaleDateString('en-US');
      } else {
        const d = new Date();
        endDate = d.toLocaleDateString('en-US');
        d.setDate(d.getDate() -  this.monthNumber[1]);
        startDate = d.toLocaleDateString('en-US');
      }
      this.widgetLoader.totalDownloads = true;
      this.baseService.GET(`${this.serverUrl}/api/Dashboard/GetNumberOfApplicationDownloads/${this.selectedWinApp}?stDate=${startDate}&endDate=${endDate}`)
      .subscribe((data: totalApps) => {
        this.response.totalDownloads = data.value;
        this.widgetLoader.totalDownloads = false;
      });
    }
  }

   /**
   * triggers timechange for BarChart event
   * returns startdate and enddate .
   */
  timeChangeBarGraph(val) {
    if (val === 'barGraph') {
      let monthNum =  this.monthNumber[0];
      if (this.barTimeSelection === this.timeListDrop[2]) {
        monthNum =  this.monthNumber[0];
      }
      if (this.barTimeSelection === this.timeListDrop[3]) {
        monthNum =  this.monthNumber[2];
      }
      let startDate = '';
      let endDate = '';

      const d = new Date();
      endDate = d.toLocaleDateString('en-US');
      d.setMonth(d.getMonth() - monthNum);
      startDate = d.toLocaleDateString('en-US');
      this.widgetLoader.barGraphloaded = true;
      this.baseService.GET(`${this.serverUrl}/api/Dashboard/GetNumberOfSPUsersWRTTimeForBarChart?stDate=${startDate}&endDate=${endDate}`).subscribe((data: [totalApps]) => {
        this.barxaxisdata = [];
        this.barUsersData = [];
        for (let i = 0; i < data.length; i++) {
          this.barxaxisdata.push(data[i].key);
          this.barUsersData.push(data[i].value);
        }
        this.optionsHighChart.xAxis.categories = this.barxaxisdata;
        this.optionsHighChart.series[0].data = this.barUsersData;
        if (!this.gridView) {
          Highcharts.setOptions({ colors: ['#26A6E0', '#F7A35C', '#1A79A9', '#90ED7D', '#434348', '#434348'] });
          this.chart1 = Highcharts.chart('container', this.optionsHighChart);
        }
        this.widgetLoader.barGraphloaded = false;
      });

    }
  }

   /**
   * triggers fullscreen event
   * chart/Graph opens in fullscreen mode
   */
  enterFS(ele) {
    if (ele.requestFullscreen) {
      ele.requestFullscreen();
    } else if (ele.webkitRequestFullscreen) {
      ele.webkitRequestFullscreen();
    } else if (ele.mozRequestFullScreen) {
      ele.mozRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
      ele.msRequestFullscreen();
    } else {
      //Sonar Fix
    }
  }
   /**
   * triggers downloadChart event
   * downloads barchart JPEG image into local machine .
   */
  public downloadChartOne() {
    this.chart1.exportChartLocal({ 'type': 'image/jpeg' });
  }
   /**
   * triggers downloadChart event
   * downloads barchart JPEG image into local machine .
   */
  public downloadChartTwo() {
    this.chart2.exportChartLocal({ 'type': 'image/jpeg' })
  }

   /**
   * get UserApplictaionAccess list 
   * returns application accessed users list
   */
  getUserApplictaionAccess() {
    this.widgetLoader.tableone = true;
    this.baseService.GET(this.serverUrl + `/api/Dashboard/GetUserApplicationAccessForGrid`).subscribe((data: []) => {
      this.response.accessTableData = data;
      this.widgetLoader.tableone = false;
    })
  }

  /**
   * get ApplictaionDownloads list 
   * returns application Downloads users list
   */
  getUserApplictaionDownloads() {
    this.widgetLoader.tabletwo = true;
    this.baseService.GET(this.serverUrl + `/api/Dashboard/GetUserApplicationDownloadsForGrid`).subscribe((data: []) => {
      this.response.downloadTableData = data;
      this.widgetLoader.tabletwo = false;
    })
  }

  /**
   * get ApplictaionDownloads list in excel
   * downloads application Downloads users list in  to excel file
   */  
  downloadTableTwo() {
    const d = new Date();
    const today = d.toLocaleDateString();
    this.widgetLoader.tabletwo = true;
    this.baseService.DOWNLOADGet(this.serverUrl + `/api/Dashboard/GetUserApplicationDownloadsForExport`).subscribe((data) => {
      const blob = new Blob([data]);
      saveAs(blob, `App_downloads_${today}.xlsx`);
      this.widgetLoader.tabletwo = false;
    },
    /* istanbul ignore next */
      (_err) => {
        this.widgetLoader.tabletwo = false;
      });
  }
  /**
   * get Applictaion access list in to excel
   * downloads application accessed users list in to excel file
   */ 
  downloadTableOne() {
    const d = new Date();
    const today = d.toLocaleDateString();
    this.widgetLoader.tableone = true;
    this.baseService.DOWNLOADGet(this.serverUrl + `/api/Dashboard/GetUserApplicationAccessExport`).subscribe((data) => {
      const blob = new Blob([data]);
      saveAs(blob, `App_access_${today}.xlsx`);
      this.widgetLoader.tableone = false;
    },
    /* istanbul ignore next */
      (_err) => {
        this.widgetLoader.tabletwo = false;
      });
  }
  /**
   * Bar Chart configuration
   * Generates bar Chart based on given options
   */ 
  public optionsHighChart:any = {
    chart: {
      type: 'column',
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    xAxis: {
      categories: [],
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Users per month'
      },
      stackLabels: {
        enabled: true,
        verticalAlign: 'top',
      }
    },
    tooltip: {
      headerFormat: '<span style = "font-size:10px">{point.key}</span><table>'
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        stacking: 'normal'
      }
    },
    series: [{
      name: 'Users Count',
      data: []
    }
    ]
  }
/**
   * Pie Chart configuration
   * Generates Pie Chart based on given options
   */ 
  public optionPieChart:any = {
    chart: {
      plotBorderWidth: null,
      plotShadow: false
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y}</b> <br><b>{point.percentage:.1f} %</b>'
    },
    exporting: {
      enabled: false
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        shadow: false,
        size: '75%',
        allowPointSelect: true,
        slicedOffset: 5,
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y} <br> {point.percentage:.1f} %',
        }
      }
    },
    series: [{
      type: 'pie',
      name: '',
      sliced: true,
      data: [
      ]
    }]
  }

}
